import { useEffect } from 'react';

function useColorfulBalls() {
  useEffect(() => {
    if (navigator.userAgent === 'ReactSnap') {
      return
    }
    // Some random colors
    const colors = ["#E73564", "#2C9DFF", "#F85F08", "#15CC05"];
  
    const numBalls = 30;
    const balls: HTMLDivElement[] = [];

    const minSize = 0.5;
    const maxSize = 1.5;

    for (let i = 0; i < numBalls; i++) {
      let ball = document.createElement("div");
      ball.classList.add("ball");
      ball.style.background = colors[Math.floor(Math.random() * colors.length)];
      ball.style.left = `${Math.floor(Math.random() * 100)}vw`;
      ball.style.top = `${Math.floor(Math.random() * 100)}vh`;
      ball.style.transform = `scale(${Math.random()})`;
      ball.style.width = `${Math.floor((Math.random() * (maxSize - minSize + 1)) + minSize)}em`;
      ball.style.height = ball.style.width;
      
      balls.push(ball);
      document.body.append(ball);
    }
  
    // Keyframes
    balls.forEach((el, i, ra) => {
      let to = {
        x: Math.random() * (i % 2 === 0 ? -11 : 11),
        y: Math.random() * 12
      };
  
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      let anim = el.animate(
        [
          { transform: "translate(0, 0)" },
          { transform: `translate(${to.x}rem, ${to.y}rem)` }
        ],
        {
          duration: (Math.random() + 1) * 2000, // random duration
          direction: "alternate",
          fill: "both",
          iterations: Infinity,
          easing: "ease-in-out"
        }
      );
    });

    return () => {
      const ballElements = document.getElementsByClassName('ball')
      Array.from(ballElements).forEach((el) => {
        el.parentNode?.removeChild(el);
      })
    }
  }, [])
}

export default useColorfulBalls
